import PropTypes from 'prop-types'
import React from 'react'
import MyRoutesModule from 'components/routes/MyRoutesModule'
import Modal from 'components/util/Modal'
import Svg from 'components/util/Svg'
import styles from './_routeSelectModal.css'

function RouteSelectModal (props) {
  return (
    <Modal effect='pop' {...props} preventBodyScroll={false}>
      <div className={styles.container}>
        <MyRoutesModule onSelect={props.onSelectRoute} />
        <Svg className={styles.closeButton} name='x' onClick={props.onRequestedClose} />
      </div>
    </Modal>
  )
}

RouteSelectModal.propTypes = {
  onRequestedClose: PropTypes.func,
  onSelectRoute: PropTypes.func,
}

export default RouteSelectModal



// WEBPACK FOOTER //
// ./src/components/routes/RouteSelector/RouteSelectModal.jsx